import { render, staticRenderFns } from "./ImpresionPtiv5.vue?vue&type=template&id=2113bf82&scoped=true"
import script from "./ImpresionPtiv5.vue?vue&type=script&lang=js"
export * from "./ImpresionPtiv5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2113bf82",
  null
  
)

export default component.exports